import React from 'react';

export type CustomMedia<TLayout extends string, TLayoutExtension extends string> = {
  [key in TLayout | TLayoutExtension]?: string;
};

export interface MatchesEvent {
  matches: boolean;
}

export const callbacks = {
  setMatchedState<T>(layout: T, setState: (layout: T) => void, e: MatchesEvent) {
    if (e.matches) {
      setState(layout);
    }
  },
};

export type Messages<TLayout, TLayoutExtension> = {
  layout: TLayout;
  layoutExtension: TLayoutExtension;
};

export type Signals = {

};

export const responsiveStateHooks = {
  useResponsiveState<TLayout extends string, TLayoutExtension extends string>(
    customMedia: CustomMedia<TLayout, TLayoutExtension>,
    layouts: TLayout[],
    layoutExtensions: TLayoutExtension[],
    setLayout: (layout: TLayout) => void,
    setLayoutExtension: (layoutExtension: TLayoutExtension) => void,
  ) {

    React.useEffect(() => {
      const listeners: [MediaQueryList, () => void][] = [];
      layouts
        .forEach(name => {
          const mediaQuery = customMedia[name];
          if (mediaQuery) {
            const query = window.matchMedia(mediaQuery);
            const listener = callbacks.setMatchedState.bind(null, name, setLayout);

            query.addListener(listener);
            listener(query);

            listeners.push([query, listener]);
          }
        });
      layoutExtensions
        .forEach(name => {
          const mediaQuery = customMedia[name];
          if (mediaQuery) {
            const query = window.matchMedia(mediaQuery);
            const listener = callbacks.setMatchedState.bind(
              null, name, setLayoutExtension);

            query.addListener(listener);
            listener(query);

            listeners.push([query, listener]);
          }
        });

      return () => {
        listeners.forEach(([query, listener]) => {
          query.removeListener(listener);
        });
      };

      // Call it once - by design
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  },
};
